import { render, staticRenderFns } from "./popup-position.mpx?vue&type=template&id=950fa754&isComponent&outputPath=components%2Fpopup-position27af6990%2Findex"
import script from "./popup-position.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-position27af6990%2Findex"
export * from "./popup-position.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-position27af6990%2Findex"
import style0 from "./popup-position.mpx?vue&type=style&index=0&id=950fa754&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_27af6990%22%7D&isComponent&outputPath=components%2Fpopup-position27af6990%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports